export default __webpack_public_path__ + "static/media/melissa_cloud_sea.57145003.jpg";